import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        width: '100%',
        borderRadius: '3px',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});

const DthIcon = (props) => {
    const propsInline = { hoverColor: PRIMARY_COLOR() };

    const classesInline = useStyles(propsInline);
    const classes = commonStyle();

    const [colorNonSelected, setColorNonSelected] = useState(
        classes.svg_non_selected
    );
    const [colorSelected, setColorSelected] = useState(classes.svg_selected);

    function MouseOver(event) {
        setColorSelected(classes.svg_white);
        setColorNonSelected(classes.svg_white);
    }
    function MouseOut(event) {
        setColorSelected(classes.svg_selected);
        setColorNonSelected(classes.svg_non_selected);
    }

    return (
        <>
            <div
                className={classesInline.dashboardserviceicons}
                onMouseOver={MouseOver}
                onMouseOut={MouseOut}
            >
                <p>
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        style={{
                            enableBackground: 'new 0 0 512 512',
                            width: '36px'
                        }}
                    >
                        <path
                            className={colorNonSelected}
                            d="M258.7,247.2l19.4-19.4c7.4,4,15.8,6.2,24.8,6.2c29,0,52.6-23.6,52.6-52.5c0-29-23.6-52.5-52.6-52.5
	s-52.5,23.6-52.5,52.5c0,8.9,2.3,17.4,6.2,24.8l-19.4,19.4L98.1,86.6c-2.9-2.9-6.7-4.5-10.8-4.5s-7.9,1.6-10.8,4.5
	c-32.2,32.2-45,79.4-36.1,132.9c6.3,38,23.2,76,48.4,110.2L28,491.4c-1.8,4.7-1.1,9.9,1.7,14.1c2.9,4.1,7.5,6.6,12.5,6.6h213.4
	c5.1,0,9.8-2.5,12.7-6.7c2.8-4.2,3.4-9.6,1.5-14.3l-20.5-50.3c5.2,1.3,10.4,2.3,15.6,3.2c11.1,1.9,21.9,2.8,32.4,2.8
	c40,0,75-13.3,100.4-38.8c2.9-2.9,4.5-6.7,4.5-10.8s-1.6-7.9-4.5-10.8L258.7,247.2z M302.9,159.4c12.2,0,22.1,9.9,22.1,22.1
	s-9.9,22.1-22.1,22.1s-22.1-9.9-22.1-22.1S290.8,159.4,302.9,159.4z M269.9,413.9c-45.4-7.6-91.3-32.6-129.1-70.4
	S78,259.9,70.4,214.4c-6.2-37.2,0-70.2,17.6-94.7l276.4,276.4C340.2,413.8,307.2,420.1,269.9,413.9z M233,481.5H64.3l47-124.8
	c2.6,2.8,5.3,5.6,8,8.3c27.5,27.5,59,48.9,91.8,63L233,481.5z"
                        />
                        <path
                            className={colorSelected}
                            d="M303.9,64.9c-8.4,0-15.3,6.8-15.3,15.2s6.8,15.2,15.3,15.2c47.4,0,86,38.6,86,86c0,8.4,6.8,15.3,15.2,15.3
	s15.2-6.8,15.2-15.3C420.5,117.2,368.2,64.9,303.9,64.9z"
                        />
                        <path
                            className={colorSelected}
                            d="M303.9,0c-8.4,0-15.3,6.8-15.3,15.2s6.8,15.2,15.3,15.2c83.3,0,151,67.7,151,151c0,8.4,6.8,15.3,15.2,15.3
	c8.4,0,15.3-6.8,15.3-15.3C485.4,81.4,404,0,303.9,0z"
                        />
                    </svg>
                </p>
                <h6>DTH</h6>
            </div>
        </>
    );
};

export default DthIcon;
